import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-black shadow-lg shadow-[#0047AB]/20' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/4829b03613a060f08ec5d40ad6d56bd7.png" 
              alt="Gamer Station - Loja de Games Santa Ifigênia" 
              title="Gamer Station - Consoles e Games em São Paulo"
              className="h-[94px] w-auto object-contain"
            />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('produtos')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">
              Consoles
            </button>
            <button onClick={() => scrollToSection('produtos')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">
              Jogos
            </button>
            <button onClick={() => scrollToSection('assistencia')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">
              Assistência
            </button>
            <button onClick={() => scrollToSection('localizacao')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer">
              Localização
            </button>
            <a 
              href="https://wa.me/5511951063038" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#0047AB] text-white px-6 py-2.5 rounded-lg hover:bg-[#003380] transition-all duration-300 text-sm font-semibold whitespace-nowrap cursor-pointer shadow-lg shadow-[#0047AB]/30"
            >
              Falar no WhatsApp
            </a>
          </nav>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-black border-t border-[#0047AB]/30 py-4">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('produtos')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium text-left px-4 cursor-pointer">
                Consoles
              </button>
              <button onClick={() => scrollToSection('produtos')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium text-left px-4 cursor-pointer">
                Jogos
              </button>
              <button onClick={() => scrollToSection('assistencia')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium text-left px-4 cursor-pointer">
                Assistência
              </button>
              <button onClick={() => scrollToSection('localizacao')} className="text-gray-300 hover:text-[#0047AB] transition-colors duration-300 text-sm font-medium text-left px-4 cursor-pointer">
                Localização
              </button>
              <a 
                href="https://wa.me/5511951063038" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#0047AB] text-white px-6 py-2.5 rounded-lg hover:bg-[#003380] transition-all duration-300 text-sm font-semibold text-center mx-4 cursor-pointer"
              >
                Falar no WhatsApp
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}